<template>
  <section class="group flex flex-col gap-4 w-full h-auto">
    <slot name="image" />
  </section>
</template>

<script setup lang="ts">
defineSlots<{
  image?(): any;
}>();
</script>
